import type { T } from '../../lib/i18n-core';

/**
 * 상품 종류 표기 — 카드·리스트·상세·필터 탭이 **같은 라벨과 같은 색**을 쓴다.
 *
 * 단어는 사전에 하드코딩하지 않는다 — 고객사가 "단과" 를 "강좌" 로 바꿔 부르므로
 * 용어 토큰(§16-18)으로 두고 `t()` 가 마켓 사전으로 치환한다.
 * 색은 가이드가 종류마다 정해 둔 것이다(`badge-type bg-*`).
 */
/**
 * 강좌 목록이 보는 종류 — 단과·패키지·프리패스. **교재는 뺀다**.
 * 현행 `Goods.php lecture()` 의 `ptype='PFL'` 을 계승한다(교재는 `/books` 가 본다).
 * 종류 탭의 '전체' 도 이 범위다.
 */
export const LECTURE_TYPES = 'LECTURE,PACKAGE,FREEPASS';
/** 교재 목록의 범위 — 현행 `Goods.php book()` 의 `ptype='B'` */
export const BOOK_TYPES = 'BOOK';

const TYPE_COLOR: Record<string, string> = {
  LECTURE: 'bg-blue',
  PACKAGE: 'bg-purple',
  FREEPASS: 'bg-green',
  BOOK: 'bg-yellow',
};

export const badgeClass = (type: string) => TYPE_COLOR[type] ?? 'bg-blue';

export const typeLabel = (type: string, t: T) =>
  ({
    LECTURE: t('prd.type.lecture'),
    PACKAGE: t('prd.type.package'),
    FREEPASS: t('prd.type.freepass'),
    BOOK: t('prd.type.book'),
    /*
     * 혜택 증정 줄에만 나오는 둘 — 상품이 아니라 쿠폰·포인트를 준다
     * (엔진 `ptype` C/O, 현행 계승). 상품 목록에는 나올 일이 없다.
     */
    COUPON: t('prd.type.coupon'),
    POINT: t('prd.type.point'),
  })[type] ?? type;

/** 단가 종류 표기 — 세분화를 쓰는 마켓에서 라디오 라벨로 쓴다(현행 lecture_prd_1/2/3) */
export const platformLabel = (platform: string, t: T) =>
  ({
    ALL: t('prd.platform.all'),
    PC: t('prd.platform.pc'),
    MOBILE: t('prd.platform.mobile'),
  })[platform] ?? platform;
